import { SwitchUniverseParams } from '@weenat/client/dist/core/analytics'
import { Universe } from '@weenat/client/dist/core/universes'
import { useOrgContext } from 'app/orgProvider'
import usePlotsOrDevicesFromPathname from 'app/src/hooks/usePlotsOrDevicesFromPathname'
import ChipsTabs from 'app/src/kit/chips-tabs/ChipsTabs'
import ChipsTabsItem from 'app/src/kit/chips-tabs/ChipsTabsItem'
import FadeIn from 'app/src/kit/animations/FadeIn'
import { useUniverse } from 'app/state'
import { logSwitchUniverse } from 'app/utils/analytics'
import isNil from 'lodash-es/isNil'
import useUniverseOptionsQuery from './useUniverseOptionsQuery'

const UniverseChipsTabs = ({ omit }: { omit?: Universe[] }) => {
  const [currentUniv, setUniv] = useUniverse()
  const org = useOrgContext()
  const plotsOrDevices = usePlotsOrDevicesFromPathname()

  const { universeOptions: allUniverseOption, universesRequest } = useUniverseOptionsQuery(org.id)

  const universeOptions = !isNil(omit)
    ? allUniverseOption.filter((univOption) => !omit.includes(univOption.value))
    : allUniverseOption

  const onChange = (u: Universe) => {
    if (!isNil(plotsOrDevices)) {
      logSwitchUniverse({
        action: `${plotsOrDevices}_switch_universe`,
        selected: Universe[u] as SwitchUniverseParams['selected']
      })
    }
    setUniv(u)
  }

  return universesRequest.isSuccess ? (
    <FadeIn>
      <Box $pointerEvents='auto'>
        <ChipsTabs value={currentUniv} onChange={onChange}>
          {universeOptions.map((opt) => (
            <ChipsTabsItem
              key={opt.value}
              value={opt.value}
              label={opt.label}
              isDisabled={opt.isDisabled}
              indicator={opt.indicator}
              $isRounded
              $isShadowed
            />
          ))}
        </ChipsTabs>
      </Box>
    </FadeIn>
  ) : null
}

export default UniverseChipsTabs
